import { useState } from 'react';
import { Twitter, Facebook, Linkedin } from 'lucide-react';

export function Footer() {
  const [logoError, setLogoError] = useState(false);

  const handleSocialShare = (platform: string) => {
    const shareText = 'Fund a car with your people — FAM makes community vehicle financing real.';
    const shareUrl = 'https://fam.autos';
    const shareUrls: Record<string, string> = {
      twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(shareUrl)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`,
    };
    window.open(shareUrls[platform], '_blank');
  };

  return (
    <footer className="bg-gradient-to-r from-indigo-900 to-gray-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <a href="/" className="flex items-center gap-2">
            {!logoError ? (
              <img
                src="/fam-logo.png"
                alt="FAM"
                className="h-8 w-8 object-contain"
                style={{ mixBlendMode: 'multiply' }}
                onError={() => setLogoError(true)}
              />
            ) : (
              <div className="h-8 w-8 rounded-full bg-indigo-500/30 flex items-center justify-center">
                <span className="text-white font-black text-xs">F</span>
              </div>
            )}
            <span className="font-semibold">FAM</span>
            <span className="text-indigo-300 text-sm">Family & More</span>
          </a>

          <div className="flex items-center gap-6 flex-wrap justify-center">
            <a href="/privacy" className="text-indigo-300 hover:text-white transition-colors text-sm">Privacy Policy</a>
            <a href="/privacy#plaid" className="text-indigo-300 hover:text-white transition-colors text-sm">Plaid & Data</a>
            <a href="/dealers" className="text-indigo-300 hover:text-white transition-colors text-sm">Dealer Portal</a>
            <a href="mailto:support@fam.autos" className="text-indigo-300 hover:text-white transition-colors text-sm">
              support@fam.autos
            </a>
          </div>

          <div className="flex items-center gap-4">
            <button onClick={() => handleSocialShare('twitter')} className="text-indigo-300 hover:text-white transition-colors">
              <Twitter className="w-5 h-5" />
            </button>
            <button onClick={() => handleSocialShare('facebook')} className="text-indigo-300 hover:text-white transition-colors">
              <Facebook className="w-5 h-5" />
            </button>
            <button onClick={() => handleSocialShare('linkedin')} className="text-indigo-300 hover:text-white transition-colors">
              <Linkedin className="w-5 h-5" />
            </button>
          </div>
        </div>
        <div className="text-center mt-6 text-indigo-400 text-xs">
          © {new Date().getFullYear()} FAM · fam.autos · All rights reserved.
        </div>
        <div className="text-center mt-2 text-xs text-gray-600">
          · <a href="/admin" className="hover:text-gray-400 transition-colors">Admin</a> · <a href="/dev" className="hover:text-gray-400 transition-colors">Dev</a> ·
        </div>
      </div>
    </footer>
  );
}
